// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ic5wp","question":"styles_question__2P52a","description":"styles_description__6_kf0"};